<template>
  <!-- Table Container -->
  <table class="w-full border-separate border-spacing-0">
    <thead class="sticky -top-2 z-10">
      <tr class="child:border-b child:border-gray-200 bg-gray-50">
        <th class="text-left py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.labour') }}
        </th>

        <th class="text-left py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.supplier') }}
        </th>

        <th
          class="text-left py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase"
          title="The labour classification reference for skill rating"
        >
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.cwRef') }}
        </th>

        <th class="text-left py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.employment') }}
        </th>

        <th class="text-right py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.rate') }}
        </th>

        <th class="text-right py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.totalHrs') }}
        </th>

        <th class="text-right py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.accrual') }}
        </th>

        <th class="text-right py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.paidToDate') }}
        </th>

        <th class="text-right py-3 px-4 font-semibold text-gray-900 text-xs tracking-wider uppercase">
          {{ $t('SelfPerform.LabourDashboard.LabourList.table.totalCost') }}
        </th>
      </tr>

      <!-- Summary Totals Row -->
      <tr
        class="sticky top-8 bg-white child:border-b child:border-gray-200 z-10"
        data-test="totals"
      >
        <td
          colspan="5"
          class="py-3 px-4"
        >
          <span class="font-semibold text-gray-900">{{ $t('SelfPerform.LabourDashboard.LabourList.table.totals') }}</span>
        </td>

        <td
          class="py-3 px-4 text-right font-semibold text-gray-900"
          data-test="totals-hours"
        >
          {{ $props.labours.reduce((total, value) => total + value.totalHours, 0).toLocaleString('en-AU', { maximumFractionDigits: 2, minimumFractionDigits: 2}) }}
        </td>

        <td
          class="py-3 px-4 text-right font-semibold text-gray-900"
          data-test="totals-accrual"
        >
          {{ $tcc($props.labours.reduce((total, value) => total + value.totalAccrual, 0)) }}
        </td>

        <td
          class="py-3 px-4 text-right font-semibold text-gray-900"
          data-test="totals-paid-to-date"
        >
          {{ $tcc($props.labours.reduce((total, value) => total + value.paidToDate, 0)) }}
        </td>

        <td
          class="py-3 px-4 text-right font-semibold text-blue-600"
          data-test="totals-total"
        >
          {{ $tcc($props.labours.reduce((total, value) => total + (value.paidToDate + value.totalAccrual), 0)) }}
        </td>
      </tr>
    </thead>

    <tbody class="bg-white">
      <LabourListRow
        v-for="labour in $props.labours"
        :key="labour.id"
        :labour="labour"
        @show-update-modal="$event => showUpdateModal($event)"
      />
    </tbody>
  </table>

  <!-- Update Modal -->
  <div>
    <LabourSaveModal
      v-if="show"
      :labour-id="selectedLabourId"
      :project-id="$props.projectId"
      @close="show = false"
    />
  </div>
</template>

<script setup lang="ts">
import Labour from '@/models/Labour';
import { ref } from 'vue';
import LabourListRow from './LabourListRow.vue';
import LabourSaveModal from './LabourSaveModal.vue';

defineProps<{
  labours: Labour[];
  projectId: string;
}>();

const show = ref(false);
const selectedLabourId = ref(undefined);

const showUpdateModal = (id: Id) => {
  selectedLabourId.value = id;
  show.value = true;
};
</script>

<style scoped></style>
